import React, { createContext, useContext, useReducer } from 'react';
import '../css/noification_component.css';

const NotificationContext = createContext();

const ADD = 'ADD';
const REMOVE = 'REMOVE';

const reducer = (state, action) => {
  switch (action.type) {
    case ADD:
      return [...state, action.payload];
    case REMOVE:
      return state.filter(n => n.id !== action.payload);
    default:
      return state;
  }
};

let counter = 0;

export const NotificationProvider = ({ children }) => {
  const [notifications, dispatch] = useReducer(reducer, []);

  const notify = (type, message, duration = 5000) => {
    const id = ++counter;
    dispatch({ type: ADD, payload: { id, type, message } });
    setTimeout(() => {
      dispatch({ type: REMOVE, payload: id });
    }, duration);
  };

  return (
    <NotificationContext.Provider value={notify}>
      {children}
      <div className="notification-container">
        {notifications.map(({ id, type, message }) => (
          <div key={id} className={`notification ${type}`}>
            {message}
          </div>
        ))}
      </div>
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const notify = useContext(NotificationContext);
  if (!notify) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return notify;
};
